import { useTheme } from "@emotion/react";
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Grid, List, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import { useFamilyNameList } from "../../fetch/fetchClassificationItems";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { usePhoneMode } from "../../hooks";

export default function FaultListSubMenu({ familyNameId }) {
    const { phoneMode } = usePhoneMode();
    const location = useLocation();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = !!anchorEl;

    const theme = useTheme();
    const { familyNames } = useFamilyNameList(true);
    const selectedFamily = familyNames.filter(it => it.id == familyNameId)[0];

    const handleClickListItem = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (_event, familyNameId) => {
        setAnchorEl(null);

        const params = new URLSearchParams(location.search);
        let navigateUrl = `/literature/fault/${familyNameId}/?${params.toString()}${window.location.hash}`;
        if (familyNameId === null) {
            navigateUrl = `/literature/fault/?${params.toString()}${window.location.hash}`;
        }
        navigate(navigateUrl);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Grid container style={{ height: theme.subBar.height, background: '#FFF' }}>
            <Grid item>
                <List component='nav' aria-label='fault-family' style={{ padding: 0 }}>
                    <ListItemButton
                        id='fault-family-button'
                        aria-haspopup="listbox"
                        aria-controls="fault-family-menu"
                        aria-label="fault family"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClickListItem}
                        style={{
                            padding: '4px 4px 4px 16px',
                            margin: '4px 8px',
                            background: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            borderRadius: theme.shape.borderRadius,
                            boxShadow: theme.shadows[2]
                        }}
                    >
                        <ListItemText
                            primary={!!selectedFamily ? `${!phoneMode ? 'Faults for ' : ''}${selectedFamily?.name}` : "Select Family"}
                        />
                        <ListItemIcon style={{ minWidth: 32 }}>
                            <KeyboardArrowDownIcon style={{ color: theme.palette.primary.contrastText }} />
                        </ListItemIcon>
                    </ListItemButton>
                </List>
                <Menu
                    id="fault-family-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'fault-family-button',
                        role: 'listbox',
                    }}
                >
                    <MenuItem
                        selected={!selectedFamily}
                        onClick={(event) => handleMenuItemClick(event, null)}
                    >
                        {!!selectedFamily ? 'Clear Family' : 'Select Family'}
                    </MenuItem>
                    {familyNames.map((familyName) => (
                        <MenuItem
                            key={familyName.id}
                            selected={familyName.id === selectedFamily?.id}
                            onClick={(event) => handleMenuItemClick(event, familyName.id)}
                        >
                            {familyName.name}
                        </MenuItem>
                    ))}
                </Menu>
            </Grid>
            {!!selectedFamily ? (
                <Grid item>
                    <Button
                        title="Clear Family"
                        style={{ margin: '6px 0px' }}
                        onClick={(event) => handleMenuItemClick(event, null)}
                    >
                        Clear
                    </Button>
                </Grid>
            ) : null}
        </Grid>
    );
}